import { useEffect } from 'react';

export const useDocumentHead = ({
  title,
  description,
  keywords,
  canonical,
  ogTitle,
  ogDescription,
  ogUrl,
  ogType = 'website',
  ogImage,
  twitterTitle,
  twitterDescription,
  twitterCard = 'summary_large_image',
  structuredData
}) => {
  useEffect(() => {
    // Set title
    if (title) {
      document.title = title;
    }

    // Create or update meta tags
    const setMeta = (name, content, property = false) => {
      if (!content) return;
      
      const attribute = property ? 'property' : 'name';
      const selector = property ? `meta[property="${name}"]` : `meta[name="${name}"]`;
      
      let meta = document.querySelector(selector);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(attribute, name);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    };

    // Set canonical link
    const setCanonical = (url) => {
      if (!url) return;
      
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement('link');
        link.rel = 'canonical';
        document.head.appendChild(link);
      }
      link.href = url;
    };

    // Set structured data
    const setStructuredData = (data) => {
      if (!data) return;
      
      // Remove existing structured data
      const existing = document.querySelector('script[data-structured-data]');
      if (existing) {
        existing.remove();
      }
      
      // Add new structured data
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-structured-data', 'true');
      script.textContent = JSON.stringify(data);
      document.head.appendChild(script);
    };

    // Update meta tags
    setMeta('description', description);
    setMeta('keywords', keywords);
    setMeta('og:title', ogTitle, true);
    setMeta('og:description', ogDescription, true);
    setMeta('og:url', ogUrl, true);
    setMeta('og:type', ogType, true);
    setMeta('og:image', ogImage, true);
    setMeta('twitter:card', twitterCard);
    setMeta('twitter:title', twitterTitle);
    setMeta('twitter:description', twitterDescription);
    
    setCanonical(canonical);
    setStructuredData(structuredData);

    // Cleanup function to restore original title
    return () => {
      if (title) {
        document.title = 'Eseky - Chess Opening Courses';
      }
    };
  }, [
    title,
    description,
    keywords,
    canonical,
    ogTitle,
    ogDescription,
    ogUrl,
    ogType,
    ogImage,
    twitterTitle,
    twitterDescription,
    twitterCard,
    structuredData
  ]);
};

export default useDocumentHead;